import { Box, Button, Divider, Image, Text } from '@wix/design-system';
import { UploadExport } from '@wix/wix-ui-icons-common';
import { FC } from 'react';
import clsx from 'clsx';
import { fillProfileUrl } from '../../../utils/urlUtils';
import { useProfileContext } from '../../Contexts/ProfileContext';
import ProviderReviewSummary from '../ProviderReviewSummary';
import ContactButton from '../ContactPanel/ContactButton';
import s from './MiniContactPanel.module.scss';

type Props = {
  onContactClicked?: () => void;
  copy?: (value: string) => Promise<void>;
  onCopyClicked?: () => void;
  shareUrl: string;
  isVisible: boolean;
};

const MiniContactPanel: FC<Props> = ({
  onContactClicked,
  copy,
  onCopyClicked,
  shareUrl,
  isVisible,
}) => {
  const { partnerProfile } = useProfileContext();

  return (
    <div className={clsx(s.stickyNav, isVisible && s.visible)}>
      <Box
        direction="vertical"
        height="77px"
        dataHook="profile-mini-contact-panel"
      >
        <Box
          backgroundColor="#fff"
          direction="horizontal"
          padding="18px 24px"
          align="space-between"
        >
          <Box
            dataHook="profile-mini-contact-panel-personal-info-container"
            gap="6px"
            alignContent="baseline"
          >
            <Box className={s.profileImageContainer}>
              <Image
                alt=""
                borderRadius="100px"
                transparent
                width="36px"
                height="36px"
                src={fillProfileUrl(
                  partnerProfile?.professionalInformation?.profileImage || '',
                  180,
                  180,
                )}
              />
            </Box>
            <Box direction="vertical" marginRight="24px">
              <Box>
                <Text
                  className={s.text}
                  size="small"
                  weight="bold"
                  maxLines={1}
                >
                  {partnerProfile.professionalInformation?.businessName}
                </Text>
              </Box>
              <ProviderReviewSummary
                isStickyMobileView={true}
                isMobileView={true}
              />
            </Box>
          </Box>
          <Box gap={'6px'} alignSelf="center">
            <ContactButton
              onContactClicked={onContactClicked}
              buttonProps={{
                className: s.contactButton,
                dataHook: 'profile-mini-contact-button',
                size: 'small',
              }}
            />
            <Button
              className={s.shareButton}
              dataHook="profile-mini-share-button"
              priority="secondary"
              skin="dark"
              size="tiny"
              onClick={() => {
                copy?.(shareUrl);
                onCopyClicked?.();
              }}
            >
              <UploadExport />
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider className={s.divider} />
    </div>
  );
};

export default MiniContactPanel;
